import React from "react";
import json_data from "./Discography.json";
import btn_play from "./icons/play.svg";
import btn_pause from "./icons/pause.svg";
import "./disc.css";

const CD = ({ idCD, lang, CD, onPlay }) => {
  return (
    <div className="disc">
      <div className="disc-name">{CD.title}</div>
      <div className="disc-img">
        <img src={"/mp3/" + CD.image} alt="CD" />
      </div>
      <div className="disc-year">{json_data.year[lang] + " " + CD.year}</div>
      {CD.soldout ? (
        <React.Fragment>
          {", "}
          <div className="disc-soldout">{json_data.sold[lang]}</div>
        </React.Fragment>
      ) : (
        ""
      )}
      {CD.zip === "" ? (
        ""
      ) : (
        <div className="disc-zip">
          {json_data.download[lang] + " "}
          <a href={"./mp3/" + CD.zip}>{CD.zip}</a>
        </div>
      )}
      <div className="disc-list">
        <div className="disc-list-title">
          <div className="disc-list-title-name">{CD.title}</div>
          <div className="disc-list-title-available">
            {CD.zip === "" ? json_data.mp3List[lang] : json_data.mp3ListFull[lang]}
          </div>
        </div>
        <ul>
          {CD.trackList.map((track, idx) => (
            <li key={idx}>
              <img
                src={track.playing ? btn_pause : btn_play}
                alt="play"
                onClick={() => onPlay(idCD, idx)}
              />{" "}
              {track.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CD;



// WEBPACK FOOTER //
// ./src/components/Discography/Disc.jsx